/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface GrantPermissionRequest
 */
export interface GrantPermissionRequest {
  /**
   *
   * @type {string}
   * @memberof GrantPermissionRequest
   */
  teamMemberId: string;
  /**
   *
   * @type {string}
   * @memberof GrantPermissionRequest
   */
  permission: string;
}

/**
 * Check if a given object implements the GrantPermissionRequest interface.
 */
export function instanceOfGrantPermissionRequest(
  value: object,
): value is GrantPermissionRequest {
  if (!("teamMemberId" in value) || value["teamMemberId"] === undefined)
    return false;
  if (!("permission" in value) || value["permission"] === undefined)
    return false;
  return true;
}

export function GrantPermissionRequestFromJSON(
  json: any,
): GrantPermissionRequest {
  return GrantPermissionRequestFromJSONTyped(json, false);
}

export function GrantPermissionRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): GrantPermissionRequest {
  if (json == null) {
    return json;
  }
  return {
    teamMemberId: json["teamMemberId"],
    permission: json["permission"],
  };
}

export function GrantPermissionRequestToJSON(
  json: any,
): GrantPermissionRequest {
  return GrantPermissionRequestToJSONTyped(json, false);
}

export function GrantPermissionRequestToJSONTyped(
  value?: GrantPermissionRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    teamMemberId: value["teamMemberId"],
    permission: value["permission"],
  };
}
